import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

export default function (ComposedComponent) {

    class Authenticate extends Component {

        static contextTypes = {
            router: PropTypes.object.isRequired
        };

        render() {
            return <ComposedComponent {...this.props} />;
        }
    }

	Authenticate.propTypes = {
		isAuthenticated: PropTypes.bool.isRequired,
	};

    function mapStateToProps(state) {
        return {
            isAuthenticated: state.auth.isAuthenticated
        };
    }

    return connect(mapStateToProps)(Authenticate);
}
